// extracted by mini-css-extract-plugin
export default {"container":"Documentation_container__8WDc6","response_code":"Documentation_response_code__gKoOO"};